// Multi-select for atomic sub-field rows (Title / Item 1 / Item 2 …).
// Selection shape: { boxId, path, paths, anchor }
//   path   — primary (last clicked) field; AnimationPanel reads its values.
//   paths  — every selected field, in row order; bulk apply writes to all.
//   anchor — Shift+click range origin.
// Selection never spans two boxes: a click on another box's row starts over.
//
// mods: { toggle } (Ctrl/Cmd+click) adds/removes one row,
//       { range }  (Shift+click) selects anchor..clicked inclusive.
export function nextSubFieldSelection(prev, boxId, path, orderedPaths = [], mods = {}) {
  const single = { boxId, path, paths: [path], anchor: path };
  if (!prev || prev.boxId !== boxId) return single;

  const prevPaths = prev.paths || (prev.path ? [prev.path] : []);
  const order = (list) =>
    orderedPaths.length ? orderedPaths.filter((p) => list.includes(p)) : list;

  if (mods.range) {
    const anchor = prev.anchor ?? prev.path;
    const a = orderedPaths.indexOf(anchor);
    const b = orderedPaths.indexOf(path);
    if (a === -1 || b === -1) return single;
    const [lo, hi] = a < b ? [a, b] : [b, a];
    return { boxId, path, paths: orderedPaths.slice(lo, hi + 1), anchor };
  }

  if (mods.toggle) {
    if (prevPaths.includes(path)) {
      const paths = prevPaths.filter((p) => p !== path);
      if (!paths.length) return null;
      const primary = prev.path === path ? paths[paths.length - 1] : prev.path;
      return { boxId, path: primary, paths: order(paths), anchor: prev.anchor ?? primary };
    }
    return { boxId, path, paths: order([...prevPaths, path]), anchor: path };
  }

  return single;
}

// Every selected path of a selection (old single-path shape included).
export function selectedSubFieldPaths(sel) {
  if (!sel) return [];
  if (Array.isArray(sel.paths) && sel.paths.length) return sel.paths;
  return sel.path ? [sel.path] : [];
}
